export enum Sidebar {
  ToolPanel = 'toolPanel',
  ScenesPanel = 'scenesPanel'
}

export type SidebarState = {
  [key in Sidebar]: boolean;
};
